import { CrmContactMergeFeaturePage } from "..";

/** CRM 重复联系人合并路由页面。 */
export function CrmContactMergePage() {
  return <CrmContactMergeFeaturePage />;
}
